import { useState, useEffect, useContext, useReducer,useRef } from "react";
import { useHistory } from "react-router-dom";

import { useQuestionnaire } from "../../../../Hooks/useQuestionnaire";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { useAddressApi } from "../../../../Hooks/useAddressApi";
import { useFollowupUserQuestions } from "../../../../Hooks/useFollowupUserQuestions";
import { getPageName } from "../../../../Constants/PageNames";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";

import diamond from "../../../../assets/UFC_DC_V1/img/diamond.png";
import ssl from "../../../../assets/UFC_DC_V1/img/ssl.png";
import excellent_review from "../../../../assets/UFC_DC_V1/img/excellent-review.svg";
import pound from "../../../../assets/UFC_DC_V1/img/pound.png";
import bg_money_sml from "../../../../assets/UFC_DC_V1/img/bg-money-sml.png";
import logo_white from "../../../../assets/UFC_DC_V1/img/logo-white.png";
import GtmDataLayer from "../../../../Utility/GtmDataLayer";
import charterhouseclaims from "../../../../assets/UFC_DC_RF_V1/img/charterhouseclaims.png";
import pdf from "../../../../assets/MOCK_OD/img/pdf-svgrepo-com.svg";

import LoaNew from "../../Layouts/UFC_DC_RF_V1/LoaNew";
import ChAuthNew from "../../Layouts/UFC_DC_RF_V1/ChAuthNew";
import ChWelcomePcp from "../../Layouts/UFC_DC_RF_V1/ChWelcomePcp";
import TermsAndCondtion from "../../Layouts/UFC_DC_RF_V1/TermsAndCondtion";
import Privacypolicy from "../../Layouts/UFC_DC_RF_V1/Privacypolicy";
import ReferralFee from ".././UFC_DC_RF_V1/ReferralFee";
import Footer from '../../../Includes/Layouts/UFC_DC_RF_V1/Footer';
import ExampleConsentForm from ".././UFC_DC_RF_V1//ExampleConsentForm";
import CHSummAndInfo from ".././UFC_DC_RF_V1/CHSummAndInfo";
import KeyFacts from ".././UFC_DC_RF_V1/KeyFacts";



const initialState = {
  questOne: "hide",
  questTwo: "hide",
  // questThree: "hide",
};
console.log("initialState", initialState);
const QuestionnaireReducer = (state, action) => {
  switch (action.type) {
    case "showSlideChange": {
      const updatedState = Object.keys(state).reduce((acc, key) => {
        acc[key] = key === action.payload ? "show" : "hide";
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 500);
        return acc;
      }, {});
      return { ...state, ...updatedState };
    }
    default:
      return state;
  }
};



const CreditCheckQuestions_FLP_OD_V2 = ({
  selectedBank,
  allFollowupData,
  removeFromPending,
  creditPendingSlides,
  uuid,
  userData,
}) => { 
  const query = new URLSearchParams(window.location.search);
  const [questOne, setQuestOne] = useState("show");
  const [questTwo, setQuestTwo] = useState("hide");
  const [showRefundSection, setShowRefundSection] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  // const [questThree, setQuestThree] = useState("hide");
  const [bacKbtnId, setBacKbtnId] = useState("1");
  const [estimatedRefund, setEstimatedRefund] = useState("");
  const [unaffordableRefund, setUnaffordableRefund] = useState("");
  const [question118, SetQuestion118] = useState("");
  const { isLoading, SaveQuestionnaire } = useQuestionnaire();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const formdata = JSON.parse(localStorage.getItem("formData"));
  const query_string = localStorage.getItem("queryString");
  const { savePageLoad, calledOnce } = usePageLoad();
  const splitName = localStorage.getItem("split_name");
  // const uuid = visitorParameters.visitor_parameters.uuid;
  const history = useHistory();
  const { addressCheck } = useAddressApi();
  let nextPage = "questionaireUFC_DC_V3";
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  const [state, dispatch] = useReducer(QuestionnaireReducer, initialState);
  const flp_source = allFollowupData.atp_sub6;
  const [dropdown, setDropdown] = useState(false);
  const [loa, setLoa] = useState(false);
  const [chAuth, setChAuth] = useState(false);
  const [chWelcomePcp, setChWelcomePcp] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [referralFee, setReferralFee] = useState(false);
  const myRef = useRef(null);
  const [exampleConscentForm, setExampleConscentForm] = useState(false);
  const [CHsumm, setCHSumm] = useState(false);
  const [keyFacts, setKeyFacts] = useState(false);

 

  useEffect(() => {
    // Set a timeout to scroll into view after 2 seconds (2000ms)
    const timer = setTimeout(() => {
      if (myRef.current) {
        myRef.current.scrollIntoView({
          behavior: "smooth", // Optional: smooth scroll
          block: "start",     // Aligns the element at the top of the viewport
        });
      }
    }, 500); // Delay in milliseconds (2 seconds)

    // Cleanup timeout if component unmounts or effect re-runs
    return () => clearTimeout(timer);
  }, [state.questOne]);

  useEffect(() => {
    slideChange(creditPendingSlides);
  }, [creditPendingSlides]);

  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("credit_check_question_FLP_OD_V2"),
        status: "visited",
        source: flp_source,
      };
      (async () => {
        await savePageLoad(
          uuid,
          data,
          "visited_status",
          splitName,
          query_string,
          allFollowupData
        );
      })();
    }
  }, [uuid, calledOnce]);

  const removePendingSlides = (slidename) => {
    const index = creditPendingSlides.indexOf(slidename);
    if (index > -1) {
      creditPendingSlides.splice(index, 1);
    }

    slideChange(creditPendingSlides);
  };

  const slideChange = (pendingQuestionSlides) => {
    let pendingCount = pendingQuestionSlides.length;
    if (pendingCount == 0) {
      removeFromPending("creditCheck_Questions");
      return false;
    }
    pendingQuestionSlides?.every((element) => {
      dispatch({ type: "showSlideChange", payload: element });
    });
  };

  const completePageLeadStatus = () => {
    const data = {
      uuid,
      page_name: getPageName("credit_check_question_FLP_OD_V2"),
      status: "completed",
      source: flp_source,
    };
    (async () => {
      await savePageLoad(
        uuid,
        data,
        "visited_status",
        splitName,
        query_string,
        allFollowupData
      );
    })();
  };

  let question_data = {};

  const storeQuestionnire = async (question_data) => {
    const response = await saveFollowupUserQuestions(
      question_data,
      allFollowupData,
      "followup_question_store"
    );
  };
  let flage = false;

  const nextQuestion = (e) => {
    if (e.target.name == "check1") {
      flage = true;
      question_data = {
        question_id: 118,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
      if (e.target.value == "326" ){
        removePendingSlides("questOne");
      } else if (e.target.value == "327") {
        removeFromPending("chDocPreview");
        removePendingSlides("questOne");
      } 
    }

    if (e.target.name == "check2") {
      flage = true;
      question_data = {
        question_id: 115,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
      if (e.target.value == "320"  || e.target.value == "321") {
        completePageLeadStatus();
        // addressCheck({ 'uuid': uuid }, userData);
        // removePendingSlides("questThree");
        removePendingSlides("questTwo");
      }
      // removePendingSlides("questTwo");
    }

    // if (e.target.name == "check3") {
    //   flage = true;
    //   question_data = {
    //     question_id: 118,
    //     option_id: e.target.value,
    //     answer_text: null,
    //     input_answer: null,
    //   };
    //   completePageLeadStatus();
    //   addressCheck({ 'uuid': uuid }, userData);
    //   // removePendingSlides("questThree");
    // }

    if (flage) {
      storeQuestionnire(question_data);
      let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (_existingEntries == null) _existingEntries = [];
      let existingIndex = _existingEntries.findIndex(
        (entry) => entry.question_id === question_data.question_id
      );
      if (existingIndex !== -1) {
        _existingEntries.splice(existingIndex, 1);
      }
      _existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(_existingEntries));
    }
  };

// Updated prevQuestion function
// const prevQuestion = () => {
//   const newId = Math.max(1, bacKbtnId - 1); // Ensure bacKbtnId doesn't go below 1

//   setBacKbtnId(newId); // Update the back button ID
//   setBtnDisable(newId === 1); // Disable the button if the ID is 1

//   switch (newId) {
//     case 1:
//       setShowRefundSection("");
//       setQuestOne("show");
//       setQuestTwo("hide");
//       break;

//     case 2:
//       setquestTwo("hide");
//       setQuestTwo("show");
//       break;

//     default:
//       console.warn("Unexpected value in prevQuestion:", newId);
//   }
// };



   return (
    <>
      <section className={`banner inner parallax-container `}>
        <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
          <img src={bg_money_sml} alt="" />
        </div>
        <div className="container">
          <div>
            <div className="brand">
              <div className="logo pt-3">
                <a href="index.html">
                  <img src={logo_white} height="60" alt="" />
                </a>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div className="container pt-3 px-lg-2 px-md-2 px-sm-0 px-0  ">
          <div className="inner-section   ">
            <div className="body-questionnaire mb-4">
              <div className="inner rounded-4">
                <div className="swiper qsSlider slide-up-now">
                  <div className="swiper-wrapper">
                    <div className={`swiper-slide slide-up-now ${state.questOne}`}>
                      <h2 className="qs-title  " >
                       While reviewing the information in your Credit Report, we’ve identified a potential opportunity to pursue further claims for mis-sold car finance.
                      </h2>
                      <p className="fs-16" ref={myRef}>
                        We believe our partner, Charterhouse Claims, a premier claims management company, 
                        is well suited to support you with this claim for{" "}
                        <mark className="text-highlight">
                          an opportunity to earn £1,000's* or more per car loan!
                        </mark>
                        . If you would like, we may refer your details to them.
                      </p>
                      <ul className="list-content list-cont-sty mt-lg-0 mt-2 mb-0">
                        <li>
                          You do not need to use a claims management company to
                          make a complaint, you can make a complaint to the
                          lender, or you can refer your claim to the Financial
                          Ombudsman Service (FOS) yourself for free.
                        </li>
                        <li>
                          Charterhouse Claims provide a no win no fee service**.
                          we will charge a fee of between 18-36% (inclusive of
                          VAT) of your compensation, The fee structure can be
                          viewed
                          <button
                            className="btn btn-link fw-semibold ps-1 click-style"
                            onClick={() => setKeyFacts((prev) => !prev)}
                          >
                            here
                          </button>
                        </li>
                        <li>
                          We may receive a
                          <button
                            className="btn btn-link fw-semibold ps-1 click-style"
                            onClick={() => setReferralFee((prev) => !prev)}
                          >
                            referral-fee
                          </button>
                        </li>
                      </ul>
                      <ul className="btn-option optinal-items  two-options  py-3   ">
                        <li>
                          <div
                            className=" option_but animation-effct"
                            onClick={nextQuestion}
                          >
                            <input
                              type="radio"
                              id="326"
                              value="326"
                              name="check1"
                            />
                            <label
                              for="326"
                              className=" align-items-center endQuest "
                            >
                              <div> Yes, Please Pursue</div>
                            </label>
                          </div>
                        </li>
                        <li>
                          <div className="option_but" onClick={nextQuestion}>
                            <input
                              type="radio"
                              id="327"
                              name="check1"
                              value="327"
                            />
                            <label for="327" className="endQuest">
                              <div> No, Thank You </div>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <div className="d-flex justify-content-center ch_house_claims">
                        <img
                          src={charterhouseclaims}
                          alt="charterhouseclaims"
                        />
                      </div>
                      <p className="text-center p-14">
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            setDropdown((prev) => !prev);
                          }}
                        >
                          View Charterhouse Claims Documents
                        </a>
                      </p>
                      {dropdown && (
                        <div className="side-toggle bg-white px-3 py-2 mb-3 rounded-3 shadow-sm">
                          <ul className="links ps-0 mt-0 mb-0">
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setLoa((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Letter of Authority
                              </a>
                            </li>
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setChAuth((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Certificate of Authenticity
                              </a>
                            </li>
                            {/* <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setKeyFacts((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Key Facts
                              </a>
                            </li> */}
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setCHSumm((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Charterhouse Summary Information
                              </a>
                            </li>
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setExampleConscentForm((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Consent Form
                              </a>
                            </li>
                            <li></li>
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setPrivacyPolicy((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Privacy Policy
                              </a>
                            </li>
                            {/* <li>
                              <button
                                className="btn btn-link fnt-sml"
                                onClick={() => {
                                  setChWelcomePcp((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Welcome Letter
                              </button>
                            </li> */}
                            <li>
                              <a
                                className="fnt-sml"
                                onClick={() => {
                                  setTermsAndConditions((prev) => !prev);
                                }}
                              >
                                <img src={pdf} />
                                Terms and Conditions
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                       <p className="fs-14" style={{fontFamily: "Arial, Helvetica, sans-serif",fontStyle: "italic",fontSize: "13px"}}>
                        Charterhouse Claims is authorised and regulated by the Financial Conduct Authority (FCA) 
                        for regulated claims management services. 
                        Our reference number is: 832999. 
                        You can check this on Financial Services Register at  <a
                          href="https://register.fca.org.uk" target="_blank">https://register.fca.org.uk. </a>
                         Registered address: Charterhouse Claims LTD, Stafford Court, <a href="https://www.google.com/maps/place/Stafford+Court,+145+Washway+Rd,+Sale+M33+7PE,+UK/@53.4197778,-2.3312612,17z/data=!3m1!4b1!4m6!3m5!1s0x487bac5b656ccf03:0x4747ca65c9757d20!8m2!3d53.4197778!4d-2.3312612!16s%2Fg%2F1tcvntxf?entry=ttu&g_ep=EgoyMDI1MDYwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank">145 Washway Road, Sale, Manchester, M33 7PE</a>.
                      </p>
                      <p className="fs-14">
                        *An FCA investigation revealed that the average customer
                        on a £10,000 PCP agreement over four years has been
                        overcharged by more than £1,100 (
                        <a
                          href="https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/
                        </a>
                        )
                      </p>
                       <div className="fs-14">
                         ** If we are not successful in your claim, you do not
                         pay anything. Clients have a 14 day “Cooling-Off” period
                         during which time they may cancel at any time without
                         charge. After this time, cancellation may result in the
                         application of the Cancellation Fee. For more
                         information
                         <a
                           className="btn btn-link fw-semibold ps-1 click-style btn-plese-click"
                           onClick={() => setKeyFacts((prev) => !prev)}
                         >
                           please click here
                         </a>
                       </div>
                    </div>
                    <div className={`swiper-slide slide-up-now ${state.questTwo}`}>
                      <h2 className="qs-title  ">
                        You may be eligible for significantly more than just
                        overdraft-related refunds.
                      </h2>
                      <p className="fs-16">
                        If you regularly lived in your overdraft or couldn’t
                        maintain a positive bank balance, it’s very likely that
                        other financial products or charges during that time
                        were also unaffordable. We can check these for you — for
                        free.
                      </p>

                      <ul className="btn-option optinal-items  two-options    ">
                        <li>
                          <div
                            className=" option_but "
                            onClick={nextQuestion}
                          >
                            <input
                              type="radio"
                              id="320"
                              value="320"
                              name="check2"
                            />
                            <label
                              for="320"
                              className=" align-items-center endQuest"
                            >
                              <div> Yes, Please Pursue </div>
                            </label>
                          </div>
                        </li>

                        <li>
                          <div
                            className="option_but"
                            onClick={nextQuestion}
                          >
                            <input
                              type="radio"
                              id="321"
                              name="check2"
                              value="321"
                            />
                            <label for="321" className="endQuest">
                              <div> No, Thank You </div>
                            </label>
                          </div>
                        </li>
                      </ul>
                      {/* <div className="mt-2 mb-4 text-center">
                        <div>
                          <button
                            className="back-btn mainbckBtn bi bi-chevron-left"
                            type="button"
                            value={bacKbtnId}
                            onClick={prevQuestion}
                            disabled={btnDisable}
                          >
                            Back
                          </button>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className=""></div>
                </div>
                <div className="mt-2 mb-3 justify-content-between  align-items-center text-center slide-up-now">
                  <div className="ms-auto d-flex justify-content-center g-2 pe-lg-3 pe-md-3 ps-sm-0 pe-0 mb-lg-0 mb-md-0 mb-sm-4  mb-4">
                    <div>
                      <img className="ps-2" height="28" src={ssl} alt="" />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pt-lg-4 pt-md-5 pt-sm-3 pt-3">
              <div className="d-flex text-danger">
                <div className="pe-2"></div>
                <div>
                  <p className={` text-black ${state.questTwo}`}>
                    This could include credit cards, payday loans, catalog
                    credit, or other charges that were approved while your
                    account was in a negative balance.{" "}
                    <strong>
                      Our clients average refund for each unaffordable credit is
                      £2,200*.{" "}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      {loa && <LoaNew close={() => setLoa(false)} />}
      {chAuth && <ChAuthNew close={() => setChAuth(false)} />}
      {chWelcomePcp && <ChWelcomePcp close={() => setChWelcomePcp(false)} />}
      {termsAndConditions && (
        <TermsAndCondtion close={() => setTermsAndConditions(false)} />
      )}
      {privacyPolicy && <Privacypolicy close={() => setPrivacyPolicy(false)} />}
      {referralFee && <ReferralFee close={() => setReferralFee(false)} />}
      {keyFacts && <KeyFacts close={() => setKeyFacts(false)} />}
      {CHsumm && <CHSummAndInfo close={() => setCHSumm(false)} />}
      {exampleConscentForm && (
        <ExampleConsentForm close={() => setExampleConscentForm(false)} />
      )}
      

      
    </>
  );
};
export default CreditCheckQuestions_FLP_OD_V2;
